import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { modifySoftOrder } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../../utils/math/ApplyRounding';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { TableSelect } from '../../../../../../../atomic/inputs/tableSelect/TableSelect';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const LossLimitTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const tacticId = tradePlan.exitTactics['LOSS_LIMIT']?.tacticId ?? null;
    const inPosition = tradePlan?.inPosition ?? null;
    const lossLimitMode = tradePlan.exitTactics['LOSS_LIMIT']?.lossLimitMode ?? null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;
    const amount = softOrder?.value.tacticValue.amount ?? null;
    const updateSoftOrder = (type, value) => {
      modifySoftOrder({ softOrder, type, value });
    };

    const updateTactic = (field, newValue) => {
      updatePlugins(
        'tactic',
        { [field]: newValue },
        'LOSS_LIMIT',
        tradePlanId,
        null
      );
    };
    if (!tradePlan?.exitTactics['LOSS_LIMIT']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            {inPosition && softOrder ? (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Amount
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={ApplyRounding(amount, 2)}
                      updateValue={(newValue) =>
                        updateSoftOrder('amount', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor={colors.black}
                    />
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Unit
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <TableSelect
                      color={colors.lightGrey}
                      backgroundColor={colors.black}
                      value={tradePlan.exitTactics['LOSS_LIMIT'].lossLimitMode}
                      onChange={(newValue) =>
                        updateTactic('lossLimitMode', newValue)
                      }
                      options={[
                        { label: 'Dollars', value: 'AMOUNT' },
                        { label: 'Percent', value: 'PERCENT' },
                      ]}
                    />
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Amount
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    {lossLimitMode === 'AMOUNT' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        $
                      </Body3>
                    ) : null}

                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={tradePlan.exitTactics['LOSS_LIMIT'].lossLimitMode === 'PERCENT' ? Number(tradePlan.exitTactics['LOSS_LIMIT'].amount) * 100 : tradePlan.exitTactics['LOSS_LIMIT'].amount}
                      updateValue={(newValue) =>
                        updateTactic('amount', tradePlan.exitTactics['LOSS_LIMIT'].lossLimitMode === 'PERCENT' ? Number(newValue) / 100 : newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor={colors.black}
                    />
                    {lossLimitMode === 'PERCENT' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        %
                      </Body3>
                    ) : null}
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </TabPanel>
    );
  }
);
LossLimitTacticPanel.tabsRole = 'TabPanel';
